// Cari Hareket Raporu sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.movementsReport';

export const accountMovementsReportGuide = (t: TFunction): GuideContent => ({
  layout: 'report',
  title: t(`${G}.title`, 'Cari Hareket Raporu nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu rapor, cari hesaplardaki tüm hareketleri tek ekranda toplar. Hangi hesapta, ne zaman, hangi işlem türüyle hareket olduğunu görerek tahsilat, ödeme ve bakiye takibini hızlı ve hatasız yaparsınız.'),
  regionLabels: {
    actions: t(`${G}.regions.actions`, '⋮ menüsü'),
    totals: t(`${G}.regions.totals`, 'Genel toplam'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Raporu filtreleyin'),
      text: t(`${G}.s1.text`, 'İşlem arama, cari hesap, işlem tipi, satış ekranı ve şube filtrelerini birlikte kullanabilirsiniz. Başlangıç ve bitiş tarihiyle raporu belirli bir döneme daraltın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Telefonda filtreler "Filtreler" düğmesiyle açılır.'),
        t(`${G}.s1.tip2`, 'Etkin filtreler tablonun üstünde etiket olarak görünür; her etiketin çarpısıyla tek tek, "Tüm filtreleri temizle" ile hepsini birden kaldırabilirsiniz.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Tabloyu okuyun'),
      text: t(`${G}.s2.text`, 'Her satır bir harekettir. Borç, alacak ve tutar sütunları hareketin hesaba etkisini hızlıca gösterir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Satır işlemlerini kullanın'),
      text: t(`${G}.s3.text`, 'Satırın sonundaki ⋮ menüsünden uygun kayıtlarda işlem yapabilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Satış ve alış faturalarında "Görüntüle" faturayı açar, "Kaydı Aç" faturayı düzenleme ekranına götürür.'),
        t(`${G}.s3.tip2`, '"Sil" hareketi kaldırır; silmeden önce onay istenir.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s4.title`, '4. Sayfalar arasında gezin'),
      text: t(`${G}.s4.text`, 'Sayfa başına 25, 50 veya 100 satır gösterebilir, alttaki oklarla sayfa değiştirebilirsiniz.'),
    },
    {
      region: 'totals',
      title: t(`${G}.s5.title`, '5. Genel toplamı kontrol edin'),
      text: t(`${G}.s5.text`, 'Tablonun altındaki Genel Toplam, filtrelenmiş hareketlerin toplam borç, alacak ve tutarını gösterir.'),
    },
    {
      region: 'actions',
      title: t(`${G}.s6.title`, '6. ⋮ menüsünü kullanın'),
      text: t(`${G}.s6.text`, 'Başlıktaki ⋮ menüsünde raporla ilgili işlemler bulunur. Telefonda bu işlemler ayrı düğmeler olarak görünür.'),
      tips: [
        t(`${G}.s6.tip1`, 'Loglar: hareketlerde yapılan değişikliklerin geçmişini gösterir.'),
        t(`${G}.s6.tip2`, 'Excel İndir: o anki filtre sonuçlarını Excel dosyası olarak indirir; raporu paylaşmak için kullanın.'),
        t(`${G}.s6.tip3`, 'Tabloyu Özelleştir: görünen sütunları açıp kapatırsınız. Sabit sütunlar gizlenemez; tercihleriniz bu tarayıcıda saklanır.'),
      ],
    },
  ],
});
